import styled from 'styled-components';
import { TRANSPARENT_COLOR } from '@src/styles/color';

const StyledDropzone = styled.div`
  .highlight {
    background-color: ${TRANSPARENT_COLOR.primary};
  }
`;
export { StyledDropzone };
